const CACHE_LIMIT = 50_000

function memoize(derive: (input: string) => string): (input: string) => string {
  const cache = new Map<string, string>()
  return (input: string) => {
    const hit = cache.get(input)
    if (hit !== undefined) return hit
    const value = derive(input)
    if (cache.size >= CACHE_LIMIT) cache.clear()
    cache.set(input, value)
    return value
  }
}

export const normalizeGlbName = memoize((name: string): string => {
  let n = name.replace(/\.STEP(-\d+)?$/, '')
  n = n.replace(/(\/\d+)+$/, '')
  const lastSlash = n.lastIndexOf('/')
  if (lastSlash >= 0 && !/^\d+$/.test(n.slice(lastSlash + 1))) {
    n = n.slice(lastSlash + 1)
  }
  return n
})

export const looseKey = memoize((s: string): string => s.replace(/[^a-zA-Z0-9]/g, ''))

export const stripStepSuffix = memoize((name: string): string =>
  name.replace(/\.STEP(-\d+)?$/i, ''),
)

export const stripInstanceSuffix = memoize((name: string): string => name.replace(/\/\d+$/, ''))

export const stripInstanceSuffixes = memoize((name: string): string =>
  name.replace(/(\/\d+)+$/, ''),
)

export const stripTrailingIndex = memoize((name: string): string => name.replace(/_\d+$/, ''))
